module.exports = __webpack_public_path__ + "static/media/JDOT-BNB.d6ae3691.svg";